module.exports = __webpack_public_path__ + "img/BryanJ.59a05eef.jpg";